import NamedDto from 'modules/base/dto/NamedDto';
import PredictionModelSummaryDto from './PredictionModelSummaryDto';

export default class PredictionTypeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.project = null;
		/** @type {number} */
		this.sourceDeviceType = null;
		/** @type {number} */
		this.targetDeviceType = null;
		/** @type {number} */
		this.bucketMs = null;
		/** @type {PredictionModelSummaryDto[]} */
		this.models = [];
	}

	/**
	 * @typedef {Object} _PredictionTypeEditDtoProps
	 * @property {number} project
	 * @property {number} sourceDeviceType
	 * @property {number} targetDeviceType
	 * @property {number} bucketMs
	 * @property {PredictionModelSummaryDto[]} models
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PredictionTypeEditDtoProps} PredictionTypeEditDtoProps
	 */
	/**
	 * @param {PredictionTypeEditDtoProps} props
	 * @returns {PredictionTypeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.project = props.project;
		this.sourceDeviceType = props.sourceDeviceType;
		this.targetDeviceType = props.targetDeviceType;
		this.bucketMs = props.bucketMs;
		this.models = Array.isArray(props.models)
			? props.models.map(model => new PredictionModelSummaryDto().setup(model))
			: [];
		return this;
	}
}
